import { render, staticRenderFns } from "./month_pay.vue?vue&type=template&id=b25c9c5c&scoped=true&"
import script from "./month_pay.vue?vue&type=script&lang=js&"
export * from "./month_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25c9c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25c9c5c')) {
      api.createRecord('b25c9c5c', component.options)
    } else {
      api.reload('b25c9c5c', component.options)
    }
    module.hot.accept("./month_pay.vue?vue&type=template&id=b25c9c5c&scoped=true&", function () {
      api.rerender('b25c9c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/dashboard/addon/month_pay.vue"
export default component.exports